export default {
  title: 'Reports',

  labels: {
    email: 'Email',
    daily: 'Active emails for send daily reports',
    hooks: {
      purchase_invoice: {
        create: 'Create purchase invoice',
        update: 'Update purchase invoice',
        delete: 'Delete purchase invoice'
      },
      return_purchase_invoice: {
        create: 'Create purchase refund',
        update: 'Update purchase refund',
        delete: 'Delete purchase refund'
      },
      sale_invoice: {
        create: 'Create sale invoice',
        update: 'Update sale invoice',
        delete: 'Delete sale invoice'
      },
      return_sale_invoice: {
        create: 'Create sale refund',
        update: 'Update sale refund',
        delete: 'Delete sale refund'
      }
    }
  },

  notifications: {
    edit: {
      success: 'Edit report setting successfully done',
      error: 'Edit report setting has error'
    },

    parseError: {
      email: 'Email is not valid',
      categories: 'No category selected',
      emailExist: 'Email is exist in the list'
    }
  },

  confirmations: {
    delete: {
      title: 'Delete email confirmation',
      body: 'Are you sure about delete {name}?'
    }
  },

  insert: {
    title: 'Insert report setting'
  }
}
